import * as z from 'zod/v4';
import { EnumParams } from '../events.types';

export const COST_SOURCE_VALUES = [
  'CommonChestBulk',
  'PremiumChestBulk',
  'EventGachaBulk',
  'NormalShop',
  'GuildShop',
  'VipCards',
  'PrivilegeCard',
  'DiamondCard',
] as const;

const costListRowSchema = (enums?: EnumParams) =>
  z
    .object({
      allResources: z.boolean().optional(),
      allGear: z.boolean().optional(),
      resource: enums ? z.enum(enums.ResourceType).optional() : z.string().optional(),
      gear: enums ? z.enum(enums.GearType).optional() : z.string().optional(),
      resourceCategory: enums ? z.enum(enums.ResourceCategory).optional() : z.string().optional(),
      gearRarity: enums ? z.enum(enums.Rarity).optional() : z.string().optional(),
    })
    .refine(
      row => {
        const count = [
          row.allResources !== undefined,
          row.allGear !== undefined,
          row.resource !== undefined,
          row.gear !== undefined,
          row.resourceCategory !== undefined,
          row.gearRarity !== undefined,
        ].filter(Boolean).length;
        return count === 1;
      },
      { message: 'Exactly one filter must be set per row' },
    );

export const costReductionsSectionSchema = (enums?: EnumParams) =>
  z
    .object({
      costSource: z.enum(COST_SOURCE_VALUES),
      discount: z.number().min(0).max(100),
      discountWhiteList: z.array(costListRowSchema(enums)),
      discountBlackList: z.array(costListRowSchema(enums)),
    })
    .refine(
      data => {
        const shopSources = ['NormalShop', 'GuildShop'] as const;
        if (!shopSources.includes(data.costSource as (typeof shopSources)[number])) {
          return data.discountWhiteList.length === 0;
        }
        return true;
      },
      {
        message: 'Discount whitelist is only available for NormalShop or GuildShop',
        path: ['discountWhiteList'],
      },
    );
